import { Dropdown } from 'primereact/dropdown'
import { useLog } from '../../Hooks/Features/HelpDesk/useLog'
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';

const ServiceLog = ({ projectOpts, setShowRequestPopup, callApi, editData }) => {
    const { handleChange, logRequestData, logRequestUpsert, options, handleEvent, loader } = useLog({ projectOpts, setShowRequestPopup, callApi, editData });

    return (
        <div>
            <div className="w30 mt-2">
                <div className="mt-2">Project Name</div>
                <Dropdown className="input-dd" options={projectOpts} optionLabel="project_name" value={logRequestData?.project_id} onChange={handleChange} placeholder="Project" filter filterInputAutoFocus name="project_id" />
            </div>

            {options?.envOptions?.length > 0 &&
                <div>
                    <div className="mt-2">Select Environment</div>
                    <div className="d-flex gap-1 mt-2" >
                        {options?.envOptions?.map((item, index) => (<div key={index}>
                            {item.log_environment_id !== null &&
                                <div key={item?.log_environment_id} className="d-flex align-items-center">
                                    <input type="radio" id={item?.log_environment_id} name="env_type" value={item?.log_environment_id} onChange={handleChange} checked={parseInt(logRequestData?.env_type) === item?.log_environment_id} />
                                    <label htmlFor={item?.log_environment_id} name="env_type">{item.environment_name}</label>
                                </div>
                            }
                        </div>
                        ))}
                    </div>
                </div>
            }
            <div className='col-md-4 col-12'>
                <div className="mt-2">Select Log Type</div>
                <MultiSelect
                    options={options?.logOptions}
                    filter
                    filterInputAutoFocus
                    placeholder="Select Log Type"
                    value={logRequestData.logType}
                    optionLabel="log_type_name"
                    name='logType'
                    onChange={(e) => handleChange(e)}
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'logType', logRequestData.logType, () => { }, handleEvent)}
                />
            </div>
            {options?.approverOption?.length > 0 &&
                <div>
                    <div className="mt-2">Approve By</div>
                    <div className="d-flex gap-1 mt-2" >
                        {options?.approverOption.map((item) => (<div>
                            {item.user_code !== null &&
                                <div key={item?.user_code} className="d-flex align-items-center">
                                    <input type="radio" id={item?.user_code} name="approver_user_code" value={item?.user_code} onChange={handleChange} checked={parseInt(logRequestData?.approver_user_code) === item?.user_code} />
                                    <label htmlFor={item?.user_code} name="approve_by">{item.user_display_name}</label>
                                </div>
                            }
                        </div>
                        ))}
                    </div>
                </div>
            }
            <div className="mt-2">Reason for Logs</div>
            <div>
                <textarea rows={2} placeholder="Write reason for vpn" className="w100 form-control border" name="reason" value={logRequestData?.reason} onChange={handleChange} />
            </div>
            <div className="d-flex justify-content-between">
                {logRequestData?.reason?.trim()?.split(" ")?.length > 5 ? <span></span> :
                    <span>{logRequestData?.reason?.split(" ")?.[0]?.length === 0 ? 0 : logRequestData?.reason?.trim()?.split(" ")?.length}/5 words</span>
                }
                <div className="d-flex justify-content-end align-items-center mt-3">
                    <button className="button btn-default" onClick={() => { setShowRequestPopup(false) }}>Cancel</button>
                    {
                        loader ? <button className="button btn-primary" style={{ width: "60px", height: "30px" }}>
                            <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className="button btn-primary" onClick={logRequestUpsert}>Submit</button>
                    }

                </div>
            </div>
        </div>
    )
}

export default ServiceLog